// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3a8NQ","vLegacy":"SelectSecondary_vLegacy__peVSv","error":"SelectSecondary_error__zoLlV","disabled":"SelectSecondary_disabled__JhbN_"};